import { logger } from 'logging-utils';
import { snapshot } from 'valtio';
import { calcDateRange } from '../../app/store-actions/top-bar-store-actions';
import TopBarStore from '../../app/stores/top-bar-store';
import { getAppOwnersStore } from '../../application-owners/api/applications-owners-api';
import { createFunnelGraphData } from '../../common/issues-trends/issues-trends-utils';
import executiveService from '../services';
import {
  setError,
  setLoading,
} from '../store-actions/issue-prioritization-store-actions';
import IssuePrioritizationStore from '../stores/issue-prioritization-store';

export const fetchIssuesPrioritization = async () => {
  setError(false);
  setLoading(true);

  try {
    const { displaySelectedAppOwners } = getAppOwnersStore();
    const { dateRange } = snapshot(TopBarStore);
    const [from, to] = calcDateRange(dateRange);

    const response = await executiveService.getIssuesPrioritization.execute({
      owners: displaySelectedAppOwners,
      dateRange: { from, to },
    });

    if (response) {
      IssuePrioritizationStore.rawData = createFunnelGraphData(response);
    }
  } catch (err) {
    logger.error('Failed to load/parse issue prioritization chart data');
    setError(true);
  } finally {
    setLoading(false);
  }
};
